module.exports = __webpack_public_path__ + "static/soggy-ink-26ddc3fcdd70e215c3b9892cb95a6364.png";